export const languages: Array<{ code: string; name: string }> = [
  { code: 'ru', name: 'Русский' },
  { code: 'be', name: 'Беларуская' },
  { code: 'uk', name: 'Українська' },
  { code: 'en', name: 'English' },
  { code: 'lt', name: 'Lietuvių' },
  { code: 'pl', name: 'Polski' },
];
